import {TestSite} from '../Views/Main/Index/Index'
type AllowedRolesType = 99

export let RouterObjects: { [item:string]: {   
                                                key: string,
                                                path :string,
                                                component,
                                                AllowedRoles :AllowedRolesType[],
                                                menuicon? :string,

                                                children? : { [item :string]: {

                                                    key: string,
                                                    path :string,
                                                    component,
                                                    AllowedRoles : AllowedRolesType[] ,
                                                    children? : { [item:string]: {

                                                        key: string,
                                                        path: string,
                                                        component
                                                    }

                                                        }}}}
} = {
    index: {

        key: '0',
        path: '/index',
        component: TestSite,
        AllowedRoles: [99],
/*
        children: {

            Index1: {

                key: '1',
                path:'/index',
                component: undefined,
                AllowedRoles :[99],
            }
        }
*/
    },

/*
    login: {
        path: '/login',
        component: Login,
        children: {},
        AllowedRoles: [99]
    },

    settings: {
        path: '/settings',
        component: Settings,
        children: {},
        AllowedRoles: [99]
    },

    registerLogin: {
        path: '/register-login',
        component: RegisterLogin,
        children: {},
        AllowedRoles: [99]
    },

    forgotPassword: {
        path:'/forgot-password',
        component: ForgotPassword,
        children:{},
        AllowedRoles:[99]
    }
*/
}


// WEBPACK FOOTER //
// ./src/Logic/RouterObjects.ts